import { accessRole } from "../../../helpers/access_role";
import ErrorAccess from "../../../components/Error/Content/Access";

import IndexCPNSView from "./IndexCPNS/View";
import UploadSKView from "./UploadSK/View";
import DetailPNSView from "./DetailPNS/View";
import ApproveView from "./Approve/View";

const RouteView = (props) => {
  const queryParams = new URLSearchParams(props.location.search);
  const _index_cpns = queryParams.get("index_cpns");
  const _detail_pns = queryParams.get("detail_pns");
  const _approve = queryParams.get("approve");
  const _upload_sk = queryParams.get("upload_sk");

  const _uuid = queryParams.get("uuid");

    if (_detail_pns != null) {
    return accessRole("read") ? <DetailPNSView /> : <ErrorAccess />;
  }
   else if (_approve != null) {
    return accessRole("approve") ? <ApproveView /> : <ErrorAccess />;
  }
   else if (_index_cpns != null) {
    return accessRole("create") ? <IndexCPNSView /> : <ErrorAccess />;
  }
   else if (_upload_sk != null) {
    return accessRole("approve") ? <UploadSKView /> : <ErrorAccess />;
  }
  
 

  return accessRole("read") ? <IndexCPNSView /> : <ErrorAccess />;
};
export default RouteView;
